<!--begin::Modal - Add/Edit Inspection Manager-->
<div class="modal fade" id="kt_modal_add_edit_inspection_manager" tabindex="-1" aria-hidden="true">
  <!--begin::Modal dialog-->
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <!--begin::Modal content-->
    <div class="modal-content">
      <!--begin::Modal header-->
      <div class="modal-header" id="kt_modal_add_edit_inspection_manager_header">
        <!--begin::Modal title-->
        <h2 class="fw-bold">{{ isEditMode ? 'Edit' : 'Add' }} Inspection Record</h2>
        <!--end::Modal title-->
        <!--begin::Close-->
        <div class="btn btn-icon btn-sm btn-active-icon-primary" (click)="closeModal()" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->

      <form [formGroup]="inspectionForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Stock (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Stock</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="vehicleSearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onVehicleSearchInput($event)"
                  (focus)="onVehicleInputFocus()" (blur)="onVehicleInputBlur()" placeholder="Search vehicles..."
                  autocomplete="off" [class.is-invalid]="vehicle_id?.invalid && vehicle_id?.touched"
                  [disabled]="isVehicleSelectionDisabled" [readonly]="isVehicleSelectionDisabled" />

                <!-- Vehicle Search Dropdown -->
                <div class="dropdown-menu show w-100 position-absolute"
                     style="z-index: 1050; max-height: 300px; overflow-y: auto;"
                     *ngIf="showVehicleDropdown && !isVehicleSelectionDisabled">
                  <div class="dropdown-item text-center py-2" *ngIf="isVehicleSearching">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="dropdown-item py-2" *ngFor="let vehicle of vehicleSearchResults"
                       (click)="selectVehicle(vehicle)" style="cursor: pointer;">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-35px me-3">
                        <img [src]="getVehicleImageUrl(vehicle)" alt="Vehicle" />
                      </div>
                      <div>
                        <div class="fw-bold">{{ vehicle.name || 'N/A' }}</div>
                        <div class="text-muted fs-7">{{ vehicle.car_no || 'N/A' }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-item text-center py-2 text-muted"
                       *ngIf="!isVehicleSearching && vehicleSearchResults.length === 0">
                    No vehicles found
                  </div>
                </div>

                <div class="invalid-feedback" *ngIf="vehicle_id?.invalid && vehicle_id?.touched">
                  <span *ngIf="vehicle_id?.errors?.['required']">Stock is required</span>
                </div>
              </div>
            </div>

            <!-- Destination Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Destination Country</label>
              <select class="form-select form-select-solid" formControlName="destination_country"
                      [class.is-invalid]="destination_country?.invalid && destination_country?.touched">
                <option value="">Select Country</option>
                <option *ngFor="let country of countriesList" [value]="country.name">
                  {{ country.name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="destination_country?.invalid && destination_country?.touched">
                <span *ngIf="destination_country?.errors?.['required']">Destination country is required</span>
              </div>
            </div>

            <!-- Insp Agency (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Insp Agency</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="inspAgencySearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onInspAgencySearchInput($event)"
                  (focus)="onInspAgencyInputFocus()" (blur)="onInspAgencyInputBlur()"
                  placeholder="Search inspection agencies..." autocomplete="off"
                  [class.is-invalid]="insp_agency?.invalid && insp_agency?.touched" />

                <!-- Inspection Agency Search Dropdown -->
                <div class="dropdown-menu show w-100 position-absolute"
                     style="z-index: 1050; max-height: 300px; overflow-y: auto;"
                     *ngIf="showInspAgencyDropdown">
                  <div class="dropdown-item text-center py-2" *ngIf="isInspAgencySearching">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div class="dropdown-item py-2" *ngFor="let agency of inspAgencySearchResults"
                       (click)="selectInspAgency(agency)" style="cursor: pointer;">
                    <div class="fw-bold">{{ agency.name || agency.company_name || 'N/A' }}</div>
                    <div class="text-muted fs-7" *ngIf="agency.email">{{ agency.email }}</div>
                  </div>
                  <div class="dropdown-item text-center py-2 text-muted"
                       *ngIf="!isInspAgencySearching && inspAgencySearchResults.length === 0">
                    No agencies found
                  </div>
                </div>

                <div class="invalid-feedback" *ngIf="insp_agency?.invalid && insp_agency?.touched">
                  <span *ngIf="insp_agency?.errors?.['required']">Inspection agency is required</span>
                </div>
              </div>
            </div>

            <!-- Insp Apply Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Insp Apply Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="insp_apply_date"
                     [class.is-invalid]="insp_apply_date?.invalid && insp_apply_date?.touched" />
              <div class="invalid-feedback" *ngIf="insp_apply_date?.invalid && insp_apply_date?.touched">
                <span *ngIf="insp_apply_date?.errors?.['required']">Inspection apply date is required</span>
              </div>
            </div>

            <!-- Insp Passed Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Insp Passed Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="insp_passed_date" />
            </div>

            <!-- Insp Status -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Insp Status</label>
              <select class="form-select form-select-solid" formControlName="insp_status"
                      [class.is-invalid]="insp_status?.invalid && insp_status?.touched">
                <option value="">Select Status</option>
                <option *ngFor="let status of inspectionStatusOptions" [value]="status.value">
                  {{ status.label }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="insp_status?.invalid && insp_status?.touched">
                <span *ngIf="insp_status?.errors?.['required']">Inspection status is required</span>
              </div>
            </div>

            <!-- Cost -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Cost</label>
              <div class="input-group">
                <input type="number" class="form-control form-control-solid" formControlName="cost"
                       placeholder="Enter cost" [class.is-invalid]="cost?.invalid && cost?.touched" />
                <span class="input-group-text">JPY</span>
              </div>
              <div class="invalid-feedback" *ngIf="cost?.invalid && cost?.touched">
                <span *ngIf="cost?.errors?.['pattern']">Please enter a valid cost</span>
              </div>
            </div>

            <!-- Admin Comment -->
            <div class="col-12 mb-5">
              <label class="form-label">Admin Comment</label>
              <textarea class="form-control form-control-solid" formControlName="admin_comment"
                        rows="3" placeholder="Enter admin comment"></textarea>
            </div>
          </div>
        </div>

        <!--begin::Modal footer-->
        <div class="modal-footer flex-center">
          <!--begin::Button-->
          <button type="button" class="btn btn-light me-3" (click)="closeModal()" data-bs-dismiss="modal">Cancel</button>
          <!--end::Button-->
          <!--begin::Button-->
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span class="indicator-label">{{ isEditMode ? 'Update' : 'Add' }}</span>
            <span class="indicator-progress" *ngIf="isLoading">Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
          <!--end::Button-->
        </div>
        <!--end::Modal footer-->
      </form>
    </div>
    <!--end::Modal content-->
  </div>
  <!--end::Modal dialog-->
</div>
<!--end::Modal - Add/Edit Inspection Manager-->
